import { Injectable } from '@angular/core';
import { MyOrganizationFacade } from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
@Injectable({
  providedIn: 'root',
})
export class UsersDetailDataGridService {
  event: any;
  organizationMembershipDetailsPayload: any;
  teamMembershipDetailsPayload: any;
  adminOrganizationMembershipPayload: any;
  editOrgDetails = new Subject<[any, any, any]>();
  orgDetails$ = this.editOrgDetails.asObservable();
  deleteOrgDetails = new Subject<[any]>();
  deleteOrgDetails$ = this.deleteOrgDetails.asObservable();

  editManageUserTeamMembership = new Subject<[any, any, any]>();
  editManageUserTeamMembershipData$ = this.editManageUserTeamMembership.asObservable();

  deleteManageUserTeamMembership = new Subject<[any]>();
  deleteManageUserTeamMembershipData$ = this.deleteManageUserTeamMembership.asObservable();

  editManageUserUserMembership = new Subject<[any, any, any]>();
  editManageUserUserMembershipData$ = this.editManageUserUserMembership.asObservable();

  deleteManageUserUserMembership = new Subject<[any]>();
  deleteManageUserUserMembershipData$ = this.deleteManageUserUserMembership.asObservable();

  constructor(
    private myOrganizationFacade: MyOrganizationFacade,
    private router: Router,
    private swalService: SwalService
  ) {}

  getOrganizationMembershipDetailsDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization name',
      field: 'organizationName',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      // sort:'desc',
      wrapText: true,
      autoHeight: true,
      sortable: false,
      lockVisible: true,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        !params.data.isSystem && (cellElement.style.cursor = 'pointer');
        !params.data.isSystem && (cellElement.style.textDecoration = 'underline');
        cellElement.innerHTML = `${cellValue}`;
        if (!params.data.isSystem) {
          cellElement.style.cursor = 'pointer';
        }
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          let urlSlash = this.router.url.lastIndexOf('/');
          let userId = this.router.url.slice(urlSlash + 1);
          !params.data.isSystem &&
            this.editManageUserUserMembership.next([
              params.data.id,
              userId,
              'Edit organization membership',
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RoleName',
      headerName: 'Role',
      field: 'roleName',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'IsDefault',
      headerName: 'Is default',
      field: 'isDefault',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showEdit: true,
        showDelete: true,
        value: 'organizationMember',
        deleteData: (data: any) => {
          this.deleteManageUserUserMembership.next([data.id]);
        },
        editData: (data: any) => {
          let urlSlash = this.router.url.lastIndexOf('/');
          let userId = this.router.url.slice(urlSlash + 1);
          this.editManageUserUserMembership.next([data.id, userId, 'Edit organization membership']);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  getTeamMembershipDetailsDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'Id',
      headerName: 'Id',
      field: 'Id',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TeamName',
      headerName: 'Team name',
      field: 'teamName',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      sortable: true,
      lockVisible: true,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        !params.data.isSystem && (cellElement.style.cursor = 'pointer');
        !params.data.isSystem && (cellElement.style.textDecoration = 'underline');
        cellElement.innerHTML = `${cellValue}`;
        if (!params.data.isSystem) {
          cellElement.style.cursor = 'pointer';
        }
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          !params.data.isSystem &&
            this.editManageUserTeamMembership.next([
              params.data.id,
              params.data.userId,
              'Edit team membership',
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RoleName',
      headerName: 'Role',
      field: 'roleName',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showEdit: true,
        showDelete: true,
        value: 'manageTeams',
        deleteData: (data: any) => {
          this.deleteManageUserTeamMembership.next([data.id]);
        },
        editData: (data: any) => {
          // manage user ===> team membership edit btn
          this.editManageUserTeamMembership.next([data.id, data.userId, 'Edit team membership']);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  getorganizationMembershipDetailsPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getOrganizationMembershipDetailsDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.organizationMembershipDetailsPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'Id',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getTeamMembershipDetailsPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getTeamMembershipDetailsDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.teamMembershipDetailsPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'Id',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getAdminOrganizationDetailDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'UserName',
      headerName: 'User name',
      field: 'userName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        !params.data.isSystem && (cellElement.style.cursor = 'pointer');
        !params.data.isSystem && (cellElement.style.textDecoration = 'underline');
        cellElement.innerHTML = `${cellValue}`;
        if (!params.data.isSystem) {
          cellElement.style.cursor = 'pointer';
        }
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          !params.data.isSystem &&
            this.editOrgDetails.next([params.data.id, 'Edit organization membership', true]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RoleName',
      filter: 'agTextColumnFilter',
      headerName: 'Organization role',
      field: 'roleName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'IsActive',
      filter: 'agTextColumnFilter',
      headerName: 'Is active',
      field: 'isActive',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showEdit: true,
        showDelete: true,
        value: 'organizationMember',
        deleteData: (data: any) => {
          this.deleteConfirmation(data.id);
        },
        editData: (data: any) => {
          this.editOrgDetails.next([data.id, 'Edit organization membership', true]);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }
  getAdminOrganizationDetailPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getAdminOrganizationDetailDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.adminOrganizationMembershipPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'userName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteOrgDetails.next([data]);
      }
    });
  }
}
